import BaseUrl from "../baseUrls";
import functions from "../../util/functions";

const aiUrl = BaseUrl.aiServer;

const reqAI = {
	sendMessageStream: async function (message, conversaId) {
		const banco = functions.databaseConfig();

		const response = await fetch(`${aiUrl}/ai-server/si/chat`, {
			method: "POST",
			credentials: "include",
			headers: {
				"Content-Type": "application/json",
				banco: banco,
			},
			body: JSON.stringify({
				message,
				conversaId,
			}),
		});

		if (!response.ok) {
			const errorData = await response.json();
			throw new Error(errorData.error || "Erro ao comunicar com a IA");
		}

		return response.body; // Retorna o ReadableStream (streaming)
	},
};

export default reqAI;
